// Load the SDK asynchronously
(function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1';
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

window.fbAsyncInit = function() {
    window.FB.init({
        appId: 483079745542390,
        cookie     : true,
        xfbml      : true,
        version    : 'v2.5'
    });
}


// WEBPACK FOOTER //
// ./src/SHARED/scripts/facebook.sdk.js